import { render, staticRenderFns } from "./FacilitiesModal.vue?vue&type=template&id=70a0612f&scoped=true"
import script from "./FacilitiesModal.vue?vue&type=script&lang=js"
export * from "./FacilitiesModal.vue?vue&type=script&lang=js"
import style0 from "./FacilitiesModal.vue?vue&type=style&index=0&id=70a0612f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0612f",
  null
  
)

export default component.exports